/**
 * Utility function to construct WebSocket URL
 * Uses the same origin (port 443 in production) which is proxied to backend
 */
export const getWebSocketUrl = (path = '/ws') => {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  const host = window.location.host; // Uses current host:port (443 in production)

  // Add path (ensure it starts with /)
  const finalPath = path.startsWith('/') ? path : `/${path}`;

  return `${protocol}//${host}${finalPath}`;
};

/**
 * Get WebSocket URL for a specific scan
 */
export const getScanWebSocketUrl = (scanId) => {
  return getWebSocketUrl(`/ws/scan/${scanId}`);
};
